import type { LandingPageContent } from '../types'

export const POROWNAJ_OFERTY_FOTOWOLTAICZNE: LandingPageContent = {
  slug: 'porownaj-oferty-fotowoltaiczne',
  lang: 'pl',
  topicId: 'pv-angebot-vergleichen',
  title: 'Porównaj oferty fotowoltaiczne – bez lawiny telefonów',
  metaDescription:
    'Porównaj kilka ofert fotowoltaicznych od firm rzemieślniczych - anonimowo, bez przekazywania ' +
    'Twojego numeru wszystkim naraz.',
  keywords: [
    'porównaj oferty fotowoltaiczne',
    'porównanie ofert paneli słonecznych',
    'zbierz oferty instalacji solarnej',
    'porównanie ofert PV bez telefonów',
  ],
  eyebrow: 'Jak działa porównanie',
  h1: 'Porównaj oferty fotowoltaiczne – bez lawiny telefonów, bez zobowiązań',
  intro:
    'Na klasycznych portalach porównawczych to samo zapytanie trafia zwykle jednocześnie do kilku ' +
    'firm - i przez wiele dni telefon dzwoni bez przerwy. Roofora działa inaczej: pozostajesz anonimowy, ' +
    'dopóki sam nie zdecydujesz, kto może się z Tobą skontaktować.',
  sections: [
    { type: 'heading', text: 'Tak przebiega porównanie ofert w Roofora' },
    {
      type: 'list',
      items: [
        'Złóż zapytanie: zdjęcia dachu, zdjęcie rozdzielnicy, orientacja i zużycie energii',
        'Anonimowa publikacja: firmy rzemieślnicze widzą zapytanie, ale nie Twoje dane kontaktowe',
        'Firmy składają niewiążące oferty w stałej cenie i mogą je poprawiać w dowolnym momencie',
        'Spokojnie porównujesz oferty posortowane według ceny',
        'Kontakt nawiązywany jest tylko wtedy, gdy aktywnie zgodzisz się na konkretną firmę',
      ],
    },
    { type: 'heading', text: 'Dlaczego anonimowe zapytania dają lepsze ceny' },
    {
      type: 'paragraph',
      text:
        'Firmy rzemieślnicze widzą, ile ofert zostało już złożonych - nie ich ceny. To tworzy prawdziwą ' +
        'konkurencję o Twoje zlecenie, bez tego, by ktokolwiek wykorzystał Twój numer telefonu, zanim ' +
        'w ogóle zobaczyłeś jakąkolwiek ofertę.',
    },
    { type: 'heading', text: 'Ty decydujesz, kto może się z Tobą skontaktować' },
    {
      type: 'paragraph',
      text:
        'Jeśli firma rzemieślnicza chce z Tobą porozmawiać, wysyła zapytanie o kontakt. Widzisz jej ' +
        'profil i indywidualnie decydujesz, czy ta konkretna firma otrzyma Twoje dane kontaktowe - bez ' +
        'zbiorowej zgody dla wszystkich.',
    },
    { type: 'heading', text: 'Na co zwrócić uwagę przy porównywaniu' },
    {
      type: 'list',
      items: [
        'Cena w kontekście całego pakietu, nie tylko końcowa suma',
        'Użyte moduły i falownik',
        'Zakres gwarancji na materiał i montaż',
        'Opinie z wcześniejszych projektów',
        'Jak konkretnie i zrozumiale rozpisana jest oferta',
      ],
    },
    { type: 'heading', text: 'Nie tylko kompletne systemy: można też zamówić pojedyncze usługi' },
    {
      type: 'paragraph',
      text:
        'Nie musisz zapytywać o kompletny system. Kto ma już moduły lub sam je zdobędzie, może zapytać ' +
        'wyłącznie o montaż na dachu. Kto ma już zamontowane moduły, może zapytać wyłącznie o ' +
        'instalację elektryczną (falownik, magazyn energii, zgłoszenie do operatora sieci) - oba ' +
        'warianty przechodzą przez to samo anonimowe porównanie ofert.',
    },
  ],
  faq: [
    {
      q: 'Ile ofert mniej więcej otrzymam?',
      a: 'Firmy rzemieślnicze mają 2-4 tygodnie na złożenie oferty - ile ich ostatecznie będzie, zależy od regionu i wielkości projektu. W każdej chwili widzisz, ile ofert już wpłynęło.',
    },
    {
      q: 'Czy firmy widzą oferty konkurencji?',
      a: 'Nie. Firmy rzemieślnicze widzą tylko liczbę już złożonych ofert, nie ich ceny - i mogą w dowolnym momencie dostosować własną ofertę.',
    },
    {
      q: 'Czy muszę przyjąć jakąś ofertę?',
      a: 'Nie, zbieranie i porównywanie ofert jest bez zobowiązań. Na koniec sam swobodnie decydujesz, czy i którą ofertę przyjmiesz.',
    },
  ],
  primaryCta: { label: 'Porównaj oferty bezpłatnie już teraz', action: 'customer' },
  secondaryCta: { label: 'Ile kosztuje instalacja fotowoltaiczna?', action: 'link', href: '/koszt-instalacji-fotowoltaicznej' },
  relatedLinks: [
    { label: 'Złóż zapytanie fotowoltaiczne', href: '/zlozyc-zapytanie-fotowoltaiczne' },
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
    { label: 'Koszt instalacji fotowoltaicznej', href: '/koszt-instalacji-fotowoltaicznej' },
    { label: 'Potrzebujesz tylko montażu na dachu?', href: '/montaz-paneli-fotowoltaicznych' },
    { label: 'Potrzebujesz tylko instalacji elektrycznej?', href: '/instalacja-elektryczna-fotowoltaiki' },
    { label: 'Oferty bez telefonu i bez e-maila', href: '/oferta-fotowoltaiczna-bez-telefonu' },
  ],
}
